import { render, staticRenderFns } from "./StoreDegreeStudent_2.vue?vue&type=template&id=1f2a8431&scoped=true"
import script from "./StoreDegreeStudent_2.vue?vue&type=script&lang=js"
export * from "./StoreDegreeStudent_2.vue?vue&type=script&lang=js"
import style0 from "./StoreDegreeStudent_2.vue?vue&type=style&index=0&id=1f2a8431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a8431",
  null
  
)

export default component.exports